/**
 * Bloks custom: IT-Recht policy page helpers
 * --------------------------------------------------
 * - Wraps tables inside .shopify-policy__body in scroll containers
 * - Rebuilds the policy title as a bloks-dual-heading (stacked)
 *
 * Search the codebase for "bloks-policy-pages" to find all related files.
 */

function wrapPolicyTable(table) {
  if (table.parentElement?.classList.contains('rte-table-wrapper')) return;

  const wrapper = document.createElement('div');
  wrapper.classList.add('rte-table-wrapper');
  const parent = table.parentNode;
  if (parent) {
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
}

function formatPolicyTables() {
  document.querySelectorAll('.shopify-policy__body table').forEach(wrapPolicyTable);
}

function getPolicySecondary() {
  const path = window.location.pathname;
  if (path.includes('shipping-policy')) return 'Lieferung und Versandinformationen';
  if (path.includes('refund-policy')) return 'Widerruf und Rückgabe';
  return '';
}

/**
 * Convert Shopify's policy title into the same dual-heading markup
 * used on About / Kontakt / FAQ.
 */
function restylePolicyTitle() {
  const title = document.querySelector('.shopify-policy__title');
  if (!title || title.dataset.bloksDualHeading === 'true') return;

  const existingHeading = title.querySelector('h1');
  const primaryText = (existingHeading?.textContent || title.textContent || '').trim();
  if (!primaryText) return;

  const secondaryText = getPolicySecondary();

  title.replaceChildren();
  title.classList.add('bloks-dual-heading', 'bloks-dual-heading--stacked');
  title.dataset.bloksDualHeading = 'true';

  const primary = document.createElement('h1');
  primary.className = 'bloks-dual-heading__primary';
  primary.textContent = primaryText;
  title.appendChild(primary);

  if (secondaryText) {
    const secondary = document.createElement('p');
    secondary.className = 'bloks-dual-heading__secondary';
    secondary.textContent = secondaryText;
    title.appendChild(secondary);
  }
}

function initBloksPolicyPages() {
  formatPolicyTables();
  restylePolicyTitle();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBloksPolicyPages);
} else {
  initBloksPolicyPages();
}
